import { axiosRequest } from '../middlewares/axios'
import {conf} from '../config/config'

export const simulationService = {
  getSimulation,
  getInjectionCurve,
  downloadSimulationData
}

async function getSimulation({ params } : { params:any }) {
  return await axiosRequest.postRequest(conf.API_URL + '/simulations/' + params.customerId, params)
}

async function getInjectionCurve({ params } : { params:any }) {
  return await axiosRequest.postRequest(conf.API_URL + '/simulations/injectedCurveCsv/' + params.customerId, params)
}

async function downloadSimulationData(params:any) {
  return axiosRequest.postRequest(conf.API_URL + '/simulations/export/' + params.customerId, params)
}